import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';

import CodeHeader from '@/components/CodeHeader';

interface Props {
  isOpen: boolean;
  doClose: () => void;
  apiKey: string;
}

export const NewKeyModal = ({ isOpen, doClose, apiKey }: Props) => {
  return (
    <Modal open={isOpen} onClose={doClose}>
      <ModalDialog
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-labelledby="alert-dialog-modal-title"
        aria-describedby="alert-dialog-modal-description"
        style={{ width: '50%', maxWidth: 550 }}
      >
        <CodeHeader text={'Copy your new API key'} copy={apiKey} />

        <input
          role="textbox"
          data-testid="api-key-code-card"
          className="mb-3 rounded-md border border-secondary bg-transparent px-2 py-1 font-mono outline-none"
          value={apiKey}
          onClick={(e) => {
            e.currentTarget.select();
          }}
          readOnly
        />

        <Button
          type={'button'}
          onClick={doClose}
          color="neutral"
          variant="soft"
        >
          I've saved the API key to a safe place
        </Button>
      </ModalDialog>
    </Modal>
  );
};
